import { render, staticRenderFns } from "./font-overseasreturnorder.vue?vue&type=template&id=f5e2fdfe&"
import script from "./font-overseasreturnorder.vue?vue&type=script&lang=ts&"
export * from "./font-overseasreturnorder.vue?vue&type=script&lang=ts&"
import style0 from "./font-overseasreturnorder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports